import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  // Admin session = httpOnly cookie (sent automatically); user login keeps its Bearer token.
  const token = localStorage.getItem("wp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
